import React from 'react';
import './LegalPage.css';

const DataDeletionPage = () => (
  <div className="legal-page">
    <h1>Data Deletion Request</h1>
    <p className="legal-updated">Last updated: 1 July 2026</p>

    <p>
      You can ask us to delete all data we hold on you at any time. We will
      process your request within 7 business days and email you confirmation.
    </p>

    <h2>How to request deletion</h2>
    <ol>
      <li>
        Email <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>{' '}
        from the address you used at checkout.
      </li>
      <li>Use the subject line "Data deletion request".</li>
      <li>
        If you want specific visa reference numbers removed, list them in the
        email body.
      </li>
    </ol>

    <h2>What we delete</h2>
    <ul>
      <li>Your email address from our subscribers table.</li>
      <li>Your visa reference numbers from our watchlist.</li>
      <li>Your alert history.</li>
      <li>Your web-push subscription.</li>
      <li>Your saved theme and session preferences from your browser.</li>
    </ul>

    <h2>What we keep</h2>
    <p>
      We are required to keep payment transaction records (transaction ID, date,
      amount) for tax and accounting purposes for 8 years. These records do not
      contain your visa reference numbers and are not used to contact you.
    </p>

    <h2>What we cannot delete</h2>
    <p>
      We cannot delete data we do not have. If you signed up under a different
      email address, mention that in your request so we can identify your data.
    </p>

    <h2>Questions</h2>
    <p>
      Email <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>
      with any questions about your data.
    </p>
  </div>
);

export default DataDeletionPage;
